import React, { useMemo } from 'react';
import '../../../styles/service-pages.scss';
import ServiceDetailCards from '../../../components/ServiceDetailCards';
import LatestWorkGrid from '../../../components/LatestWorkGrid';
import Seo from '../../../components/Seo';

const ProductDevelopment = () => {
  const detailItems = useMemo(() => [
    {
      title: 'Approach',
      description:
        "Every product engagement starts with understanding: what exists, who it's for, and what 'success' actually means for your business. We then work through discovery, design, prototyping, and development in a way that keeps users at the centre and the business goal in sight. We fit into your team, your tools, and your process — not the other way around.",
    },
    {
      title: 'Delivery',
      description:
        "Depending on the engagement, deliverables range from full product design systems and component libraries to production-ready front-end builds. You'll always have full visibility on progress, clear documentation, and design files that your wider team can own and build on after we're done.",
    },
    {
      title: 'Results',
      description:
        "Products that get used. That sounds obvious, but you'd be surprised. Design-led development reduces the rework cycle, improves user adoption, and creates products that grow with your business rather than needing to be rebuilt every eighteen months.",
    },
  ], []);

  return (
    <>
      <Seo 
        title="Product Development Services | Heretic Studio"
        description="We turn ideas into functional products through research, iteration, and collaboration. From early discovery to polished delivery, every step is guided by real user insight—not assumptions."
      />
      <div className="studio-page service-page service-page--product-development">
        <div className="studio-hero service-hero">
          <div className="studio-hero__content service-hero__content">
            <h1 className="studio-hero__title service-hero__title">Product Development</h1>
            <p className="studio-hero__subtitle service-hero__subtitle">From idea to reality</p>
          </div>
        </div>

        <section className="section intro service-intro">
          <div className="wrapper grid-display">
            <div className="row">
              <div className="col-12">
                <div className="blur-text blur-text--1 large center-text introtext">
                  Turning ideas into functional products through research, iteration, and collaboration
                </div>
              </div>
            </div>
          </div>
        </section>

        <ServiceDetailCards items={detailItems} />

        <LatestWorkGrid />
      </div>
    </>
  );
};

export default ProductDevelopment;
